import {
  PROSPECT_DISPOSITION_TYPES,
  PROSPECT_SYSTEM_DISPOSITION_TYPES,
} from "shared/lib/constants/dispositions";
import { ContactDetailI } from "shared/lib/interfaces/account";
import { ListPillI } from "shared/lib/interfaces/lists";
import { getS3AssetPath } from "shared/lib/helpers";
import { LISTS_ICON_MAP } from "shared/lib/constants/lists";
import { UserIcon } from "@heroicons/react/24/outline";

export const getLeadStateFlags = (contact: ContactDetailI) => {
  if (!contact?.contact_disposition_type) {
    return {
      isLeadDisqualified: false,
      isLeadMarkedDNC: false,
      isLeadSuspended: false,
    };
  }

  return {
    isLeadDisqualified: [
      PROSPECT_DISPOSITION_TYPES.BAD_DATA,
      PROSPECT_DISPOSITION_TYPES.NOT_RELEVANT,
    ].includes(contact?.contact_disposition_type),
    isLeadMarkedDNC:
      contact?.contact_disposition_type ===
      PROSPECT_DISPOSITION_TYPES.DO_NOT_CALL,
    isLeadSuspended:
      contact?.contact_disposition_type ===
      PROSPECT_SYSTEM_DISPOSITION_TYPES.SUPPRESSED,
  };
};

export interface ListActivitiesItemI extends ListPillI {
  isActive?: boolean;
  isExclusive?: boolean;
  onClick?: () => void;
}

export const getListIcon = ({
  list_type: listType,
  isExclusive,
  isWhiteAwardIcon,
}: Pick<ListActivitiesItemI, "isExclusive" | "list_type"> & {
  isWhiteAwardIcon?: boolean;
}) => {
  if (isExclusive) {
    return (
      <img
        alt="Dedicated List"
        src={getS3AssetPath(
          isWhiteAwardIcon
            ? "platform/icons/award-icon-white.webp"
            : "platform/icons/award-icon.webp"
        )}
        className="w-[18px] min-w-[18px]"
      />
    );
  }

  if (listType in LISTS_ICON_MAP) {
    return LISTS_ICON_MAP[listType as keyof typeof LISTS_ICON_MAP];
  }

  return <UserIcon className="w-4" />;
};
